import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { BackButton } from 'C4';

import logo from 'assets/images/logo/logo_wide.png';
const MobileButtons = () => (
  <div className="button__container">
    <div className="buttons small">
      {/* <img src={apple} className="apple" alt="App store" />
      <img src={google} className="google" alt="Google Play" /> */}
    </div>
  </div>
);

export default class ExternalTrainingView extends Component {
  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  render() {
    return (
      <div className="contentContainer">
        <BackButton to="/main/" />
        <div className="externalTraining__view">
          <div className="externalTraining__container">
            <a href="https://www.barceloprorewards.com" target="_blank" rel="noreferrer noopener">
              <img src={logo} alt="Logo" className="logo" />
            </a>
            <p>
              Click the link to enter the <a href="https://www.barceloprorewards.com" target="_blank" rel="noreferrer noopener">Barcelo Hotels Training Program</a>.<br /><br />
              This Sales Companion is designed to help you more easily sell Barcelo Hotels, after the training is complete! Filled with new content, promotional collateral and sales tools to help YOU be-the-expert whenever and wherever to convert more bookings, for months and years after the training is complete. Think of this tool as your mobile marketing platform to drive conversations and sales. Have a favorite page or section of the app, just tap the heart icon to favorite it for easy reference later.<br /><br />
              Here are the highlights of the new areas built to assist YOU:<br />
              <ul>
                <li><b>Discover</b> - New content and videos to help reinforce your knowledge of the destination</li>
                <li><b>Promote</b> - Start more conversations and simplify selling through sharing the resources available in this tab.</li>
                <li><b>Sell</b> - Remove the friction from the sales process with the quick and easy collateral available here.</li>
              </ul>
              <MobileButtons />
              <i>Don't forget, the <b>Barcelo Hotels Sales Companion</b> is available online, offline, anytime, anywhere. Download it from the app store now!</i>
            </p>
            <a href="https://www.barceloprorewards.com" className="britAgentLink" target="_blank" rel="noreferrer noopener">
              barceloprorewards.com
              <FontAwesomeIcon icon={['fas', 'external-link-alt']} />
            </a>
          </div>
        </div>
      </div>
    );
  }
}
